class TC_PlayerSleep {
    constructor (playerInstance) {
        this.player = playerInstance;
    }

    eventSleep (e) {
        e.stopPropagation();

        if (this.player.UI.popups.sleep.hasClass('is-hidden')) {
            this.player.UI.popups.sleep.removeClass('is-hidden');
            $(document).trigger('playerMakeOpaque');
        } else {
            this.hidePopup();
        }
    }

    initSleepEvents () {
        for (let i = 0; i < this.player.UI.buttons.sleepItems.length; i++) {
            let item = this.player.UI.buttons.sleepItems.eq(i);

            item.on('click', () => {
                let time = parseInt(item.attr('data-value'));
                item.parent().find('span.cr-player-sleep-in').removeClass('is-active');
                item.find('span.cr-player-sleep-in').addClass('is-active');
                this.sleepAudio(time);
            });
        }
    }

    sleepAudio (time) {
        this.player.sleepMode = true;

        if (this.player.sleepTimeout) {
            clearTimeout(this.player.sleepTimeout);
        }

        this.player.sleepTimeout = setTimeout(() => {
            this.player.audioVolumeOutro();
        }, time * 1000 * 60);
    }

    hidePopup () {
        this.player.UI.popups.sleep.addClass('is-hidden');
    }

    showPopup () {
        this.player.UI.popups.sleep.removeClass('is-hidden');
    }
}
